(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3d-image"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const ring  = document.getElementById('carousel-ring');
  const title = document.getElementById('carousel-title');

  /* ---------- parse data ---------- */
  let categories = [];
  try {
    categories = JSON.parse(
      document.getElementById('carousel-data').textContent
    ).categories.filter(c => c.images && c.images.length > 0);
  } catch (e) {
    console.error('Carousel JSON error:', e);
    return;
  }
  if (!categories.length) return;

  /* ---------- pick category via sessionStorage ----------
     Each page-load advances to next category in order.
     Stored index survives only within the same browser tab session.
  -------------------------------------------------------- */
  const storageKey = 'carousel_cat_index_{{ section.id }}';
  let catIndex = parseInt(sessionStorage.getItem(storageKey) || '0', 10);
  if (isNaN(catIndex) || catIndex >= categories.length) catIndex = 0;
  // save NEXT index for the following page load
  sessionStorage.setItem(storageKey, (catIndex + 1) % categories.length);

  const cat = categories[catIndex];

  /* ---------- build slides ---------- */
  const images    = cat.images;
  const total     = images.length;
  const stepAngle = 360 / total;
  // radius so slides sit comfortably without overlapping
  const radius    = Math.round((150) / Math.tan(Math.PI / total));

  images.forEach((url, i) => {
    const a = document.createElement('a');
    a.className = 'carousel-slide';
    a.href = cat.link || '#';
    a.style.backgroundImage = `url('${url}')`;
    a.style.transform = `rotateY(${i * stepAngle}deg) translateZ(${radius}px)`;
    ring.appendChild(a);
  });

  /* ---------- show category title ---------- */
  title.textContent = cat.name;
  requestAnimationFrame(() => {
    requestAnimationFrame(() => title.classList.add('show'));
  });

  /* ---------- smooth CSS-animation rotation ----------
     Using CSS animation instead of JS requestAnimationFrame
     gives perfectly smooth, GPU-accelerated loop with zero jank.
  -------------------------------------------------------- */
  const duration = total * 4; // seconds — more slides = slower feels natural
  const styleEl = document.createElement('style');
  styleEl.textContent = `
    @keyframes carousel-spin {
      from { transform: rotateY(0deg); }
      to   { transform: rotateY(-360deg); }
    }
    #carousel-ring {
      animation: carousel-spin ${duration}s linear infinite;
    }
  `;
  document.head.appendChild(styleEl);
});

  } catch(e) { console.error(e); }
})();
})();
